export default {
    stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
    stripeMonthlyPriceId: process.env.VUE_APP_STRIPE_MONTHLY_PRICE_ID,
    stripeYearlyPriceId: process.env.VUE_APP_STRIPE_YEARLY_PRICE_ID,
    appVersion: process.env.VUE_APP_VERSION,
    microsoftTenantId: process.env.VUE_APP_MICROSOFT_TENANT_ID
}
